<template>
	<div class="row centered">
		<AppTable ref="invoices-table"
			v-if="userStore.currBusinessId"
			:fetch-function="administrationStore.getFilteredInvoices"
			:filters="filters"
			:table-headings="tableHeadings"
			:title="getString('qromo_invoices')"
			:total-items="administrationStore.businessInvoicesTotal || 0"
			:items="administrationStore.businessInvoices || []"
			initial-sort-field="date"
			@failed-fetch="details=>{$emit('failed-fetch', details)}"
			allow-download
			@export="exportInvoices" >

			<template #url="{item}">
				<div class="row centered">
					<AppTableButtonGroup v-if="!!item.url" :buttons="buttonsDownload" :item="item" @picked-download="openUrl(item.url)"/>
					<div class="no-download" v-else>N/A</div>
				</div>
			</template>

		</AppTable>
	</div>
</template>

<script>
import AppTable from "@/shared/components/AppTable.vue";
import {useUserStore, useAdministrationStore} from "@/console-new/stores";
import {useCurrencyStore, useLanguageStore, useScriptStore, useNotificationStore} from "@/shared/stores";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AppTableButtonGroup from "@/shared/components/AppTableButtonGroup.vue";
import {formatDateTimeWithSeconds} from "@/shared/helpers/dates";

export default {
	setup() {
		const userStore = useUserStore();
		const administrationStore = useAdministrationStore();
		const languageStore = useLanguageStore();
		const currencyStore = useCurrencyStore();
		const scriptStore = useScriptStore();
		const notificationStore = useNotificationStore();
		return {userStore, administrationStore, getString: languageStore.getString, currencyStore, scriptStore, showNotification: notificationStore.showNotification};
	},
	name: "InvoicesTable",
	emits: ["failed-fetch"],
	components: {AppTableButtonGroup, AppButtonIcon, AppTable},
	data() {
		return {
			filters: [
				{
					type: "date",
					key: 'date',
					tableName: 'businesses_invoices',
					text: this.getString('date'),
					finalValue: '',
					active: false
				},
				{
					type: "price",
					key: "amount",
					text: this.getString('amount'),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
			],
			tableHeadings: [
				{
					text: this.getString('date'),
					cols: 1,
					sortable: true,
					fieldName: 'date',
				},
				{
					text: this.getString('amount'),
					cols: 1,
					sortable: true,
					fieldName: 'amount',
				},
				{
					text: this.getString('download'),
					cols: 1,
					fieldName: 'url',
					slotName: 'url',
				},
				{
					text: this.getString('description'),
					fieldName: 'description',
					cols: 3,
				},
			],
			
		}
	},
	computed: {
		buttonsDownload() {
			return [
			{
				iconName: "icon-download-blue",
				emitName: "picked-download",
				title: this.getString('download')
			},
		];
	},
	},
	methods: {
		openUrl(url) {
			window.open(url, '_blank');
		},
		exportInvoices(expExtension) {
			let dateKey = this.getString('date');
			let amountKey = this.getString('amount');
			let downloadKey = this.getString('download');
			let descriptionKey = this.getString('description');

			let data = [];
			if(this.administrationStore.businessInvoices) {
				data = this.administrationStore.businessInvoices.map(invoice => {
					let row = {};
					row[dateKey] = formatDateTimeWithSeconds(invoice.date, false);
					row[amountKey] = this.currencyStore.readableCurrencyValue(invoice.amount, true, false);
					row[downloadKey] = invoice.url;
					row[descriptionKey] = invoice.description;
					return row;
				});
			}

			let businessNameNorm = this.userStore.currBusiness.name.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
			let today = new Date().toLocaleString();
			let fileName = businessNameNorm+"_"+this.getString('qromo_invoices').toLowerCase()+"_"+today.replace(", ", "_");

			if(data.length > 0){
				this.scriptStore.loadScript('xlsx', () => {
					const worksheet = window.XLSX.utils.json_to_sheet(data);
					const workbook = window.XLSX.utils.book_new();
					window.XLSX.utils.book_append_sheet(workbook, worksheet, this.getString("qromo_invoices"));

					window.XLSX.utils.sheet_add_aoa(worksheet, [[dateKey, amountKey, downloadKey, descriptionKey]], {origin: "A1"});

					if (expExtension === "xlsx") {
						window.XLSX.writeFileXLSX(workbook, fileName + ".xlsx");
					} else {
						window.XLSX.writeFile(workbook, fileName + ".csv");
					}
				});
			}
			else {
				this.showNotification('table-no-data');
			}
		}
	},
	watch: {
		'userStore.currBusinessId': {
			handler(newVal, oldVal) {
				if(newVal && newVal !== oldVal) {
					if(this.$refs['invoices-table']) {
						this.$refs['invoices-table'].fetchData();
					}
				}
			},
		},
	}
}
</script>


<style lang="scss" scoped>
a:after {
	content: none;
}

.no-download {
	font-size: 12px;
}
</style>
